import classNames from 'classnames'
import * as React from 'react'
import ExpandIcon from './ExpandIcon'
import JobPositionIcon from './JobPositionIcon'
import EducationPositionIcon from './EducationPositionIcon'
import useTranslation from 'next-translate/useTranslation'

interface JobItemProps {
	type?: 'education' | 'job'
	position: string
	company: string
	dateFrom: Date
	dateTo: Date
}

export const Position: React.FC<React.PropsWithChildren<JobItemProps>> = ({
	type = 'job',
	position,
	// company,
	dateFrom,
	dateTo,
	children,
}) => {
	const [isOpen, setIsOpen] = React.useState(true)
	const { t } = useTranslation('talent')

	return (
		<li className="flex flex-col mb-5 last:mb-0">
			<div className="flex gap-4">
				{type === 'job' ? <JobPositionIcon /> : <EducationPositionIcon />}
				<div className="w-full">
					<div className="flex flex-col md:justify-between md:flex-row">
						<span>
							<div className="text-sm font-semibold md:text-base text-brand-gray-400">{position}</div>
							<div className="text-xs md:text-sm text-brand-gray-300">{t('contact-required')}</div>
						</span>
						<span>
							<span className="hidden capitalize md:text-sm md:block text-brand-gray-300">
								<span>
									{dateFrom.toLocaleDateString('pl-PL', {
										month: 'long',
										year: 'numeric',
									})}
								</span>{' '}
								-{' '}
								<span>
									{dateTo.toLocaleDateString('pl-PL', {
										month: 'long',
										year: 'numeric',
									})}
								</span>
							</span>
							{children && (
								<button
									type="button"
									className="flex items-center gap-1 mt-1 text-xs font-semibold uppercase md:mt-0 md:ml-auto text-brand-primary-md"
									onClick={() => setIsOpen(open => !open)}
								>
									{t('description')}
									<div
										className={classNames('transition-transform', {
											'rotate-90': isOpen,
										})}
									>
										<ExpandIcon />
									</div>
								</button>
							)}
						</span>
					</div>
					<div
						className={classNames(
							'pr-3 mt-2.5 md:mt-4 overflow-hidden text-xs transition-[max-height] max-h-[0px] duration-200 md:pr-5 md:text-sm text-brand-gray-300',
							{
								'max-h-[700px]': isOpen,
							},
						)}
					>
						{children}
					</div>
				</div>
			</div>
		</li>
	)
}
